import { render } from "./modal-cambia-esecutore.vue?vue&type=template&id=3fdb3851"
import script from "./modal-cambia-esecutore.vue?vue&type=script&lang=js"
export * from "./modal-cambia-esecutore.vue?vue&type=script&lang=js"

import "./modal-cambia-esecutore.vue?vue&type=style&index=0&id=3fdb3851&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__